import React from "react";

function ProjectModal({ project, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>

        {/* 2x2 IMAGE GRID */}
        <div className="modal-gallery grid-2x2">
          {project.images.slice(0, 4).map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${project.title} screenshot ${index + 1}`}
            />
          ))}
        </div>

        <h2>{project.title}</h2>
        <p>{project.description}</p>
        <p>{project.text}</p>
        <h4>Technologies Used</h4>
        <ul>
          {project.tech.map((t, index) => (
            <li key={index}>{t}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ProjectModal;
